import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MERCH_API } from 'src/app/core/constants';

import { AppService } from 'src/app/core/services/app.service';
import { listenerCount } from 'stream';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { observable, Subscription } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { MerchCartService } from 'src/app/core/services/merch-cart.service';


@Component({
  selector: 'app-product-shoppingcart',
  templateUrl: './product-shoppingcart.component.html',
  styleUrls: ['./product-shoppingcart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductShoppingcartComponent implements OnInit {
  quantity = 0;
  cartProductsList: any;
  cartItemCount: any
  pendingRemoveId: any = null;
  confirmClearAll: boolean = false;
  subTotal: any = 0


  // Dropdown (has to be removed later)
  size: any = null;
  searchCurrency: any = null;
  cart_id: any;
  organizationId:any;
  assets_url = environment.assets_url;
  currentLocation:any;
  getCurrency:any;
  currencyInfoSubscription: Subscription;
  product_info: any = {};
  channelName: string;
  settingsData: any = {};
  settingsDataSubscription: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    private toaster: ToastrService,
    private appPaymentService: AppPaymentTVService,
    private commanService: CommanSubscribeService,
    private storageService: StorageService,
    private merchCartService: MerchCartService,
    private route: ActivatedRoute,

  ) {

    this.cart_id = this.activatedRoute.snapshot.params.cart_id;
    this.product_info = this.storageService.getItem("product_info");
  }

  backClicked() {
    const userId = this.commanService.userInfo?.user_first_name + ' ' + this.commanService.userInfo?.user_last_name;
    (window as any).umami?.track(`Back Button Clicked from Cart - ${userId}`,{
      productName: this.cart_id});
    const data = {
      actionType: "product",
      metaData: {
        title: `Back Button Clicked from Cart - ${this.cart_id}`,
        cartId: this.cart_id,
        collectionId: this.product_info?.collection_id || null,
        itemCount: this.cartItemCount || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService?.slugInfo?.organization_id || null,
      networkGroupId: this.product_info?.network_group_id || this.commonSubscribeService.activeGroupId || null,
    }
    this.commanService.sendTriggeredEvent(data);
    if(this.product_info && this.product_info.collection_id && parseInt(this.product_info.collection_id) != 0){
      if(this.isMerchandiseFlow()) {
        this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + `/merchandise/product-marketplace/${this.product_info.collection_id}`]);
      }else{
        this.router.navigateByUrl(`/network-market/product-marketplace/${this.product_info.collection_id}`);
      }
    }else{
      if(this.isMerchandiseFlow()) {
        this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + '/merchandise/merch-list']);
      }else{
      this.router.navigateByUrl('/network-market/market');
      }
    }
  }

  buyNow() {
    const userId = this.commanService.userInfo?.user_first_name + ' ' + this.commanService.userInfo?.user_last_name;
    (window as any).umami?.track(`Buy Now Clicked by - ${userId}-Cart Id${this.cart_id}`);
    console.log("Buy Now Clicked", this.commanService.streamInfo);
    const payload = {
      actionType: "product",
      metaData: {
        title: `Buy Now Clicked - cartID ${this.cart_id}`,
        cartId: this.cart_id,
        collectionId: this.product_info?.collection_id || null,
        itemCount: this.cartItemCount || null,
        totalAmount: this.subTotal || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.product_info?.organization_id || null,
      networkGroupId: this.product_info?.network_group_id || null,
      clickAction: 'buy'
    }
    this.commanService.sendTriggeredEvent(payload);
    //initiate checkout
    let url = MERCH_API.INITIATE_CHECKOUT;
    let data = {
      'cart_id': this.cart_id
    }

     
     
    this.appPaymentService.postRequest(url,data ).subscribe(response => {


      if (response.status === 0) {

        this.confirmCheckOut();

      } else if (response.status === 1) {

        this.toaster.error(response.message)

      }
    }, error => {
      this.ngxLoader.stop();
      this.toaster.error(error)
    });


  }

  confirmCheckOut(){


     //initiate checkout
    let url = MERCH_API.CONFIRM_CHECKOUT;
    let cartProductIds = [] 
     this.cartProductsList.forEach(element => {

      cartProductIds.push(element.id)
      
     });

     let payload = {
      'ids':cartProductIds,
      'cart_id': this.cart_id
     }     
     
      
     this.appPaymentService.postRequest(url,payload ).subscribe(response => {
 
       if (response.status === 0) {
 
        const currentUrl = this.router.url;
         const isMerchandise = currentUrl.includes('/merchandise');
         // decide base route
         const base = isMerchandise
           ? `${this.commanService.getChannelBasePath(this.channelName)}/merchandise`
           : '/network-market';

         // navigate
         this.router.navigateByUrl(`${base}/product-shipping/${this.cart_id}`);
       } else if (response.status === 1) {
 
         this.toaster.error(response.message)
 
       }
     }, error => {
       this.ngxLoader.stop();
       this.toaster.error(error)
     });




  }
  //dropdown methods start here
  clearSearch() {

  }

  changeAttribute(selectedAttr, selectedCartProdId,productId) {
    (window as any).umami?.track(`Product ${selectedAttr.name} Changed to ${selectedAttr.value}`, {
      CartId: this.cart_id,
      userId: this.commanService.userInfo?.user_first_name + ' ' + this.commanService.userInfo?.user_last_name,
    });
    const data = {
      actionType: "product",
      metaData: {
        title: `Product ${selectedAttr.name} Changed to ${selectedAttr.value} - cartID id ${this.cart_id}`,
        cartId: selectedCartProdId,
        collectionId: this.product_info?.collection_id,
        productId: productId,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService?.slugInfo?.organization_id || this.product_info?.organization_id || null,
      networkGroupId: this.product_info?.network_group_id || this.commonSubscribeService.activeGroupId || null,
      clickAction: 'attribute-select'
    }
    this.commanService.sendTriggeredEvent(data);
    this.cartProductsList.forEach(prod => {

      if (prod.id == selectedCartProdId) {

        prod.product_data.attributes.forEach(element => {

          if (element.attribute_name == selectedAttr.name) {

            element.attributesList.forEach(att => {

              if (att.value_id == selectedAttr.value_id) {
                att['is_selected'] = true;
                element['selected_attr'] = selectedAttr.value;
              } else {
                att['is_selected'] = false;
              }

            })
          }
        });

      }
    });

    this.updateCartProduct(selectedCartProdId);

  }
  //dropdown methods end here

  increment(selectedProd) {
    (window as any).umami?.track(`Quantity plus Clicked - Cart ID: ${this.cart_id}`, {
      CartId: this.cart_id,
      userId: this.commanService.userInfo?.user_first_name + ' ' + this.commanService.userInfo?.user_last_name,
    });
    const data = {
      actionType: "product",
      metaData: {
        title: `Quantity plus Clicked - cartID ${this.cart_id}`,
        productId: selectedProd.product_id,
        collectionId: this.product_info?.collection_id,
        cartId: this.cart_id,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService?.slugInfo?.organization_id || null,
      networkGroupId: this.product_info?.network_group_id || this.commonSubscribeService.activeGroupId || null,
      clickAction: 'quantity-add'

    }
    this.commanService.sendTriggeredEvent(data);
    let callAPI = false;
    this.cartProductsList.forEach(element => {
      let prodPrice = element.product_data.price;
      if (element.id == selectedProd.id) {
        if (selectedProd.product_data.limited_inventory && selectedProd.product_data.inventory < element.quantity) {
          this.toaster.info("Only " + selectedProd.product_data.inventory + " products available");
          element.quantity = selectedProd.product_data.inventory
        }else{
          element.quantity = element.quantity + 1;
          // element.product_data.price = element.price;
          callAPI = true;

        }
        // let pricingArr;
        // if(typeof element.product_data.pricing === "string"){
        //   pricingArr = JSON.parse(element.product_data.pricing);
        // }else{
        //   pricingArr = element.product_data.pricing;
        // }

      }
    });
    if(callAPI)
      this.updateCartProduct(selectedProd.id);

  }

  decrement(selectedProd) {
    (window as any).umami?.track(`Quantity minus Clicked - Cart ID: ${this.cart_id}`, {
      CartId: this.cart_id,
      userId: this.commanService.userInfo?.user_first_name + ' ' + this.commanService.userInfo?.user_last_name,
    });
    const data = {
      actionType: "product",
      metaData: {
        title: `Quantity minus Clicked - cartID: ${this.cart_id}`,
        productId: selectedProd.product_id,
        collectionId: this.product_info?.collection_id,
        cartId: this.cart_id,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService?.slugInfo?.organization_id || null,
      networkGroupId: this.product_info?.network_group_id || this.commonSubscribeService.activeGroupId || null,
      clickAction: 'quantity-minus'
    }
    this.commanService.sendTriggeredEvent(data);
    this.cartProductsList.forEach(element => {

      if (element.id == selectedProd.id) {
        if (element.quantity < 1) {
          element.quantity = 1;
          return;
        } else {
          element.quantity = element.quantity - 1;
          // element.product_data.price = element.price;
        }
      }
    });

    this.updateCartProduct(selectedProd.id);

  }



  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['orgId']) {
        this.organizationId = Number(params['orgId']);
      }
    })
    this.settingsDataSubscription = this.commanService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
    });
    this.settingsData = this.commanService.icWebpageSettingsData;
    this.getCurrency = this.storageService.getItem('currency');
    this.channelName = this.route.parent.snapshot.params['channelName'];

    this.getcartProductsList();
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commanService.getCurrentLocation((val: any, json: any) => {
        console.log(json);
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
        }
        this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
       });
    } else if(this.currentLocation && Object.keys(this.currentLocation).length > 0){
      this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
    }
    this.currencyInfoSubscription = this.commanService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        if(this.cartItemCount > 0){

          this.updatePrice();
        }
        
      }
    });

  }

  isMerchandiseFlow(): boolean {
  return this.router.url.includes('/merchandise');
  }


  updatePrice(){
    let url = MERCH_API.UPDATE_CART_CURRENCY;
    let data = {
      "currency": this.getCurrency,
      "cart_id": this.cart_id
  }
    this.appPaymentService.postRequest(url, data).subscribe(response => {

      if (response.status === 0) {

        console.log(response, "response");
        this.getcartProductsList();
      } else if (response.status === 1) {
        this.toaster.error(response.message)

      }
    }, error => {
      this.ngxLoader.stop();
      this.toaster.error(error)
    });

  }

  getcartProductsList() {

    let url = MERCH_API.GET_CART_PRODUCTS;

    this.appPaymentService.postRequest(url, { "cart_id": this.cart_id }).subscribe(response => {
      if (response.status === 0) {
        if(this.organizationId){
          this.cartProductsList = response.result.filter(
            (item:any) => item.organization_id === this.organizationId
          );
        }else{
          this.cartProductsList = response.result;
        }
        this.cartItemCount = this.cartProductsList.length;
        this.commonSubscribeService.sendCartProductInfo(response.result);
        
        this.subTotal  = 0;
        this.cartProductsList.forEach(element => {
          element.product_data = JSON.parse(element.product_data);
          if(element.product_data.attributes && element.product_data.attributes[0].attribute_name != "null" ){
            element.product_data.attributes.forEach(prodKeys => {
              let selectedAttr = prodKeys.attributesList.filter(attr => attr.is_selected == true)
              prodKeys['selected_attr'] = selectedAttr[0].value
            });
          }
           element.product_data.price = element.price * element.quantity;
           this.subTotal = (Number(this.subTotal) + Number(element.product_data.price)  ).toFixed(2);
           element.product_data.product_img = element.product_data.media_url ? element.product_data.media_url[0] : this.assets_url + 'merch-default-image.png';
        });

      } else if (response.status === 1) {
          this.toaster.error(response.message)
        }
    }, error => {
      this.ngxLoader.stop();
      this.toaster.error(error)
    });

  }


  deleteProductFromCart(itemId,productId) {
    (window as any).umami?.track(`Product Deleted - Product Cart ID: ${itemId}`, {
      productName: itemId,
      userId: this.commanService.userInfo?.user_first_name + ' ' + this.commanService.userInfo?.user_last_name,
    });
    const data = {
      actionType: "product",
      metaData: {
        title: `Product Deleted - Product Cart ID: ${itemId}`,
        cartId: itemId,
        productId: productId,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService?.slugInfo?.organization_id || null,
      networkGroupId: this.product_info?.network_group_id || this.commonSubscribeService.activeGroupId || null,
      clickAction: 'delete'
    }
    this.commanService.sendTriggeredEvent(data);
    let url = MERCH_API.DELETE_CART_PRODUCT;

    this.appPaymentService.postRequest(url, { "item_id": itemId }).subscribe(response => {

 
      if (response.status === 0) {

        this.toaster.success(response.message)
        this.getcartProductsList();
        this.commonSubscribeService.getCartProdCountApiCallSubject.next(true);

      } else if (response.status === 1) {

        this.toaster.error(response.message)

      }
    }, error => {
      this.ngxLoader.stop();
      this.toaster.error(error)
    });


  }


  openProduct(product) {
    const base = this.isMerchandiseFlow()
      ? `${this.commonSubscribeService.getChannelBasePath(this.channelName)}/merchandise`
      : '/network-market';
    const route = this.merchCartService.overviewRoute(base, product);
    this.router.navigate(route.commands, route.extras);
  }

  moveToWishlist(product) {
    this.runCartAction(this.merchCartService.moveToWishlist([product], this.commanService.userInfo?.access_token), 'Moved to wishlist');
  }

  clearCart(toWishlist: boolean) {
    const request = toWishlist
      ? this.merchCartService.moveToWishlist(this.cartProductsList, this.commanService.userInfo?.access_token, true)
      : this.merchCartService.removeItems(this.cartProductsList, true);
    this.runCartAction(request, toWishlist ? 'Moved to wishlist' : 'Cart cleared');
  }

  private runCartAction(request, successMessage: string) {
    this.ngxLoader.start();
    request.subscribe({
      next: () => {
        this.ngxLoader.stop();
        this.pendingRemoveId = null;
        this.confirmClearAll = false;
        this.toaster.success(successMessage);
        this.getcartProductsList();
        this.commonSubscribeService.getCartProdCountApiCallSubject.next(true);
      },
      error: (message) => {
        this.ngxLoader.stop();
        this.toaster.error(typeof message === 'string' ? message : 'Something went wrong, please try again');
      }
    });
  }

  updateCartProduct(selectedProdId) {
    let selectedCartProd = this.cartProductsList.filter(prod => prod.id == selectedProdId);

    let url = MERCH_API.UPDATE_CART_PRODUCT;
    selectedCartProd = selectedCartProd[0];
    
    this.appPaymentService.postRequest(url, selectedCartProd).subscribe(response => {
      if (response.status === 0) {
        if (response.merged) {
          this.toaster.info(response.message);
          this.commonSubscribeService.getCartProdCountApiCallSubject.next(true);
        }
      } else if (response.status === 1) {
        this.toaster.error(response.message)
      }
      this.getcartProductsList();
    }, error => {
      this.ngxLoader.stop();
      this.toaster.error(error)
    });
  }
  ngOnDestroy() {
    this.settingsDataSubscription?.unsubscribe();
    this.currencyInfoSubscription?.unsubscribe();
  }
}
